import {
  APICallParams,
  APIInterfaceI,
  buildFileUploadRequest,
  buildRequest,
  PaginationT,
} from '.';

class deviceConfig implements APIInterfaceI {
  getAll = (pagination: PaginationT, params?: APICallParams) => (
    buildRequest('GET', `/scenarios/${params?.flowId}/device-configs?list_req.cursor=${pagination.cursor}&list_req.limit=${pagination.limit}`)
  )

  getOne = (targetId: string, params?: APICallParams) => (
    buildRequest('GET', `/scenarios/${params?.flowId}/device-profiles/${params?.deviceProfileId}/device-configs/${targetId}`)
  )

  register = (formData: any, params?: APICallParams) => (
    buildRequest('POST', `/scenarios/${params?.flowId}/device-profiles/${params?.deviceProfileId}/device-configs`, formData)
  )

  update = (targetId: string, formData: any, params?: APICallParams) => (
    buildRequest('PUT', `/scenarios/${params?.flowId}/device-profiles/${params?.deviceProfileId}/device-configs/${targetId}`, formData)
  )

  delete = (targetId: string, params?: APICallParams) => (
    buildRequest('DELETE', `/scenarios/${params?.flowId}/device-profiles/${params?.deviceProfileId}/device-configs/${targetId}`)
  )

  registerMulti = (
    flowId: string,
    deviceProfileId: string,
    poolIdFromSelectedFlow: string,
    deviceIDs: Array<string>,
  ) => (
    buildRequest(
      'POST',
      `/scenarios/${flowId}/device-profiles/${deviceProfileId}/device-configs/bulk-add`,
      {
        deviceIDs,
        poolId: poolIdFromSelectedFlow,
      },
    )
  )

  uploadCSV = (
    flowId: string,
    deviceProfileId: string,
    csvData: any,
  ) => (
    buildFileUploadRequest(
      'POST',
      `/scenarios/${flowId}/device-profiles/${deviceProfileId}/device-configs/csv-upload`,
      csvData,
    )
  )

  downloadCSVErrorReport = (errorTxId: string) => (
    buildRequest('GET', `/downloaderrorreport?tx_id=${errorTxId}`)
  );
}

export default deviceConfig;
